import { useCallback } from 'react';
import { Box, ButtonBase, InputBase, makeStyles } from '@material-ui/core';
import { MinusIcon, PlusIcon } from '../Icon';
import { i18n } from '../../language';

const useStyles = makeStyles(() => ({
  title: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#7d86a9',
  },
  icon: {
    color: '#538fff',
  },
  input: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1.25rem',
    color: '#3e3e3e',
    '&>input': {
      textAlign: 'center',
    },
  },
}));

const Counter = ({ onChange, value, minNum, ctrl = true }) => {
  const classes = useStyles();

  const changeHandler = useCallback(
    (event) => {
      onChange(Number(event.target.value));
    },
    [onChange]
  );

  const reduceHandler = useCallback(() => {
    if (!ctrl) {
      return;
    }

    onChange(value - 1);
  }, [value, onChange, ctrl]);

  const addHandler = useCallback(() => {
    if (!ctrl) {
      return;
    }

    onChange(value + 1);
  }, [value, onChange, ctrl]);

  return (
    <Box
      display="flex"
      border="solid 1px #e4e7eb"
      borderRadius="10px"
      p="0 0.75rem"
      width="9rem"
      height="3.5rem"
      bgcolor={ctrl ? '#fff' : '#f5f5f5'}
      justifyContent="space-between"
    >
      {ctrl && value >= minNum + 1 ? (
        <ButtonBase id="qty-reduce" onClick={reduceHandler}>
          <MinusIcon className={classes.icon} />
        </ButtonBase>
      ) : (
        <Box minWidth="1.5rem" />
      )}
      <InputBase
        id="qty-input"
        className={classes.input}
        inputProps={{ type: 'number', maxLength: '3' }}
        onChange={changeHandler}
        value={value}
        readOnly={!ctrl}
      />
      {ctrl ? (
        <ButtonBase id="qty-add" onClick={addHandler}>
          <PlusIcon className={classes.icon} />
        </ButtonBase>
      ) : (
        <Box minWidth="1.5rem" />
      )}
    </Box>
  );
};

const LongLoanReminder = ({ value, onChange, minNum }) => {
  const classes = useStyles();

  return (
    <Box display="flex" flexDirection="column" gridRowGap="0.813rem" mb="1.5rem">
      <div className={classes.title}>{i18n.t('EQUIPMENT_LONG_LOAN_REQUEST_TITLE')}</div>

      <Counter value={value} onChange={onChange} minNum={minNum} />
    </Box>
  );
};

export { Counter };

export default LongLoanReminder;
